const prefix = 'fas';
const iconName = 'circle-minus';
const width = 512;
const height = 512;
const aliases = ['minus-circle'];
const unicode = 'f056';
const svgPathData = 'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
